<template>
  <mped-cost-view-component :is-plan="false"></mped-cost-view-component>
</template>

<script>
export default  {
  name: 'mped-cost-fact-view'
}
</script>

<script setup>
import MpedCostViewComponent from '@/views/mped/components/mped-cost-view-component.vue';
</script>
